import { Time } from "@internationalized/date";
import { t } from "@lingui/core/macro";
import { LimeTimeInput } from "./LimeTimeInput";

export const LimeTimeRangeInput = ({
  fromValue,
  toValue,

  onFromChange,
  onToChange,

  isFromDisabled,
  isToDisabled,

  allowOvernight,
  overrideError,
  rightAction,
}: {
  fromValue: Time | null;
  toValue: Time | null;

  onFromChange: (value: Time | null) => void;
  onToChange: (value: Time | null) => void;

  isFromDisabled?: boolean;
  isToDisabled?: boolean;

  allowOvernight?: boolean;
  overrideError?: string;
  rightAction?: React.ReactNode;
}) => {
  const error = (() => {
    if (overrideError) {
      return overrideError;
    }

    if (
      fromValue &&
      toValue &&
      fromValue.compare(toValue) > 0 &&
      !allowOvernight
    ) {
      return t`Začetni čas ne sme biti večji od končnega časa`;
    }

    if (
      !allowOvernight &&
      fromValue &&
      toValue &&
      fromValue.compare(toValue) === 0
    ) {
      return t`Časa ne smeta biti enaka`;
    }

    return null;
  })();

  return (
    <div>
      {error && <p className="mb-1 text-xs text-red-500">* {error}</p>}

      <div
        className="flex flex-wrap items-center justify-between gap-2"
        data-identifier="time-range-input"
      >
        <div className="flex items-center gap-2">
          <LimeTimeInput
            className="w-fit"
            label={t`od`}
            labelPlacement="outside-left"
            data-identifier="time-from-input"
            value={fromValue}
            onChange={onFromChange}
            size="sm"
            isDisabled={isFromDisabled}
            isInvalid={!!error}
          />
          <LimeTimeInput
            className="w-fit"
            label={t`do`}
            labelPlacement="outside-left"
            data-identifier="time-to-input"
            value={toValue}
            onChange={onToChange}
            size="sm"
            isDisabled={isToDisabled}
            isInvalid={!!error}
          />
        </div>

        {rightAction}
      </div>
    </div>
  );
};
